<template>
  <div class="official-acc-auth">
    <pageTitle :pageTitle="$t('lang.k_319001')">
      <span class="title_tips">{{ $t('lang.k_319029') }}</span>
    </pageTitle>

    <vh-tabs class="official-acc-tabs" v-model="activeTab">
      <vh-tab-pane name="1">
        <span slot="label">
          {{ $t('lang.k_319030') }}
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              <p>{{ $t('lang.k_319002') }}</p>
              <p>{{ $t('lang.k_319003') }}</p>
              <p>{{ $t('lang.k_319004') }}</p>
              <p>{{ $t('lang.k_319005') }}</p>
              <p>{{ $t('lang.k_319006') }}</p>
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
        </span>
        <OfficialHosted v-if="activeTab == 1" />
      </vh-tab-pane>
      <vh-tab-pane name="2">
        <span slot="label">
          {{ $t('lang.k_319031') }}
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              <p>{{ $t('lang.k_319055') }}</p>
              <p>{{ $t('lang.k_319056') }}</p>
              <p>{{ $t('lang.k_319057') }}</p>
              <p>{{ $t('lang.k_319058') }}</p>
              <p>{{ $t('lang.k_319059') }}</p>
              <p>{{ $t('lang.k_319060') }}</p>
              <p>{{ $t('lang.k_319061') }}</p>
              <p>{{ $t('lang.k_319062') }}</p>
              <p>{{ $t('lang.k_319063') }}</p>
              <p>{{ $t('lang.k_319064') }}</p>
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
        </span>
        <OfficialSecret v-if="activeTab == 2" />
      </vh-tab-pane>
    </vh-tabs>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import OfficialHosted from './components/OfficialHosted.vue';
  import OfficialSecret from './components/OfficialSecret.vue';
  export default {
    name: 'OfficialAccAuth',
    components: {
      PageTitle,
      OfficialHosted,
      OfficialSecret
    },
    data() {
      return {
        activeTab: '1'
      };
    }
  };
</script>

<style lang="less" scoped>
  .official-acc-auth {
    .title_tips {
      font-size: 14px;
      color: #999;
      margin-left: 10px;
    }
    .official-acc-tabs {
      background-color: #fff;
    }
  }
</style>
